import type { TableColumnsType } from 'antd';
import type { TopicType } from './Topics.types.ts';
import * as Yup from 'yup';
import { HomeOutlined } from '@ant-design/icons';
import i18n from '../../utils/i18n.ts';

export const TOPICS_FORM = 'TopicsForm';

export const BREADCRUMBS = [
  {
    href: '/',
    title: <HomeOutlined />,
  },
  {
    href: '/',
    title: i18n.t('common.portal'),
  },
  {
    href: '/admin',
    title: i18n.t('pages.admin.title'),
  },
  {
    title: i18n.t('pages.admin.module.topics'),
  },
];

export const TOPICS_COLUMNS: TableColumnsType<TopicType> = [
  {
    title: i18n.t('pages.topics.name'),
    dataIndex: 'name',
  },
  {
    title: i18n.t('pages.topics.order'),
    dataIndex: 'order',
  },
  {
    title: i18n.t('pages.topics.type'),
    dataIndex: 'type',
    render: (value: number) => (value === 1 ? 'With children' : 'Without children'),
  },
  {
    title: i18n.t('pages.topics.parent-topic'),
    dataIndex: 'parentTopic',
    render: (value: { name: string }) => value?.name,
  },
  {
    title: i18n.t('pages.topics.is-active'),
    dataIndex: 'active',
    width: 150,
    render: (value: string) => (value ? 'Yes' : 'No'),
  },
];

export const TOPICS_FORM_SCHEMA = Yup.object().shape({
  name: Yup.string().required(i18n.t('error.validation.required-name')),
  order: Yup.string().required(i18n.t('error.validation.required-order')),
  type: Yup.string().required(i18n.t('error.validation.required-type')),
  parentTopicId: Yup.string().required(i18n.t('error.validation.required-parent-topic')),
});

export const TOPICS_INITIAL_FORM_VALUES = {
  id: '',
  name: '',
  order: 1,
  type: '',
  parentTopicId: '',
};
